	$('#ready_access' ).on("change", function() {
		if ($('#ready_access').is(':checked')){
			$('#pin4access').prop({'disabled':true,'checked':false});
		} else {
			$('#pin4access').prop("disabled", false);
		}
	});

	$('#pin4access' ).on("change", function() {
		if ($('#pin4access').is(':checked')){
			$('#ready_access').prop({'disabled':true,'checked':false});
			$('#pin').after('<div id="inputPin" class="mt-10"><h4 class="example-title">Пароль</h4><input type="text" class="form-control" placeholder="Пароль " name="pin" required="required" value=""></div>');
		} else {
			$('#ready_access').prop("disabled", false);
			$('#inputPin').remove()
		}
	});


// $(document).ready(function(){
//   $('.names-select2').select2({
//     ajax: {
//       url: '/conferences/get_all_users',
//       type: "post",
//       dataType: 'json',
//       cache: true,
//       // что будем отправлять на сервер в запросе
//       data: function (obj) {


//         return obj.term;
//       },
//        /* обрабатываем то, что пришло с сервера
//         * (напр. просто берём подмассив) */
//       processResults: function (data, params) {
//         console.log(data);
//         return {
//           results: data
//         };
//       }
//     }
//   });

// });



